<template>
    <v-footer color="primary" app>
        <span class="white--text">&copy; 2020</span>
    </v-footer>
</template>

<script>
    export default {

    }
</script>
